import {useEffect, useState} from "react";
import {participantsErrors, validateOptionalParticipantElements, validatePersonData} from "../../validation";
import {addExistSubject, getParticipantsWithRole, newGuarantor, newParticipant} from "./participant";
import {DealActionsEnums, handleDealAction} from "../../actions";
import {exceptionsTitle} from "../../dictionaries";
import {dealData} from "./deal";
import {RolesEnums} from "../../enums";
import {stateManager} from "../../stateManager";

export const useParticipants = ({role}) => {
  const [participants, setParticipants] = useState(getParticipantsWithRole(role));

  useEffect(() => {
    participants.map((participant) => {
      const errors = validatePersonData(participant)
      const errorsOpt = validateOptionalParticipantElements(participant)

      participantsErrors.set(participant.participantId, {...errors, ...errorsOpt});
    });

    setParticipants(getParticipantsWithRole(role));
  }, []);

  const addNewParticipant = async (type) => {
    const result = await newParticipant(type, role);

    if (result.ok) {
      handleDealAction(DealActionsEnums.NEW_PARTICIPANT);

      const participants = getParticipantsWithRole(role)

      participants.map((participant) => {
        const errors = validatePersonData(participant)
        const errorsOpt = validateOptionalParticipantElements(participant)

        participantsErrors.set(participant.participantId, {...errors, ...errorsOpt});
      });

      setParticipants(participants);
    } else {
      openNotify({
        msg: exceptionsTitle[result.message] || "При создании участника сделки возникла ошибка",
        duration: 10000,
        errors: result.errors,
        type: 'error',
        positionH: 'right',
      })
    }
  }

  const addGuarantor = async (name) => {
    const result = await newGuarantor(name, role);

    if (result.ok) {
      handleDealAction(DealActionsEnums.NEW_PARTICIPANT);

      const participantsWithRole = getParticipantsWithRole(role)
      participantsWithRole.map((participant) => {
        const errors = validatePersonData(participant)
        const errorsOpt = validateOptionalParticipantElements(participant)

        participantsErrors.set(participant.participantId, {...errors, ...errorsOpt});
      });

      setParticipants(participantsWithRole);
    } else {
      openNotify({
        msg: exceptionsTitle[result.message] || "При создании участника сделки возникла ошибка",
        duration: 10000,
        errors: result.errors,
        type: 'error',
        positionH: 'right',
      })
    }
  }

  const onDelete = (participantId) => {
    const idx = dealData.participants.findIndex((item) => item.participantId === participantId)
    dealData.participants.splice(idx, 1)
    setParticipants(getParticipantsWithRole(role));
  }

  const onChange = () => {
    setParticipants(getParticipantsWithRole(role));
  }

  // @TODO не реализовано до конца
  const handleAddRep = async (repsId) => {
    const result = await addExistSubject(repsId, RolesEnums.REPRESENTATIVE);

    if (result.ok) {
      const participantsWithRole = getParticipantsWithRole(role)

      participantsWithRole.map((participant) => {
        const errors = validatePersonData(participant)
        const errorsOpt = validateOptionalParticipantElements(participant)

        participantsErrors.set(participant.participantId, {...errors, ...errorsOpt});
      });

      setParticipants(participantsWithRole);
    }
  }

  const handleAddExistSubject = async (subject) => {
    const result = await addExistSubject(subject.id, role);

    if (result.ok) {
      const participantsWithRole = getParticipantsWithRole(role)

      participantsWithRole.map((participant) => {
        const errors = validatePersonData(participant)
        const errorsOpt = validateOptionalParticipantElements(participant)

        participantsErrors.set(participant.participantId, {...errors, ...errorsOpt});
      });

      setParticipants(participantsWithRole);
    } else {
      openNotify({
        msg: exceptionsTitle[result.message] || result.message || "При добавлении возникла ошибка",
        duration: 10000,
        errors: result.errors,
        type: 'error',
        positionH: 'right',
      })
    }
  }

  return {
    addNewParticipant, addGuarantor, onDelete, onChange, handleAddRep, participants, role, handleAddExistSubject
  }

}